// extracted by mini-css-extract-plugin
module.exports = {"info":"info-module--info--1XNoX","important":"info-module--important--1gExE","importantMessage":"info-module--importantMessage--156LU"};